import { useEffect, useRef } from 'react';

/*
  A custom hook that keeps track of previous props and state
  Reference: https://usehooks.com/usePrevious/
 */
export const usePrevious = (value: any): undefined => {
	const ref = useRef();
	useEffect(() => {
		// Only re-run if value is updated
		ref.current = value;
	}, [value]);

	// Return previous value (happens before the update in useEffect)
	return ref.current;
};
